// Simple Product Gallery without custom elements
(function() {
  'use strict';
  
  let currentSlide = 0;
  let mediaImages = [];
  let thumbnails = [];
  let prevButton = null;
  let nextButton = null;
  
  function init() {
    
    // Get all elements
    mediaImages = document.querySelectorAll('.product__main-image-img');
    thumbnails = document.querySelectorAll('.product__thumbnail');
    prevButton = document.querySelector('.product__nav-button--prev');
    nextButton = document.querySelector('.product__nav-button--next');
    
    if (mediaImages.length <= 1) {
      return;
    }
    
    setupThumbnails();
    setupNavigation();
    setupKeyboard();
    goToSlide(0);
  }
  
  function setupThumbnails() {
    thumbnails.forEach((thumbnail, index) => {
      const button = thumbnail.querySelector('.product__thumbnail-button') || thumbnail;
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(index);
      });
    });
  }
  
  function setupNavigation() {
    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        previousSlide();
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        nextSlide();
      });
    }
  }
  
  function setupKeyboard() {
    document.addEventListener('keydown', function(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        previousSlide();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        nextSlide();
      }
    });
  }
  
  function previousSlide() {
    const newIndex = currentSlide === 0 ? mediaImages.length - 1 : currentSlide - 1;
    goToSlide(newIndex);
  }
  
  function nextSlide() {
    const newIndex = currentSlide === mediaImages.length - 1 ? 0 : currentSlide + 1;
    goToSlide(newIndex);
  }
  
  function goToSlide(index) {
    if (index < 0 || index >= mediaImages.length) {
      return;
    }
    
    currentSlide = index;
    
    // Update images
    mediaImages.forEach((img, i) => {
      if (i === index) {
        img.style.display = 'block';
        img.classList.add('is-active');
      } else {
        img.style.display = 'none';
        img.classList.remove('is-active');
      }
    });
    
    // Update thumbnails
    thumbnails.forEach((thumb, i) => {
      if (i === index) {
        thumb.classList.add('is-active');
      } else {
        thumb.classList.remove('is-active');
      }
    });
    
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Also try to initialize after a short delay in case of timing issues
  setTimeout(init, 100);
  
})();
